export const SchoolTypes = [
  { value: 'public-district', label: 'Public District' },
  { value: 'public-charter', label: 'Public Charter' },
  { value: 'private', label: 'Private' },
  { value: 'vocational', label: 'Vocational' },
  { value: 'public-magnet', label: 'Public Magnet' },
  { value: 'special', label: 'Special' },
  { value: 'virtual-online', label: 'Virtual / Online' },
];
